import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  ContainerStyled,
  HeaderOvalStyled,
  WrapperListStyled,
  ListTitleStyled,
  FinalTextStyled,
  ContentStyled,
  ContainerGreyStyled,
} from './styles/PlanListStyled';
import MarketplaceService from '../../../services/Marketplace';
import PlanContainer from './PlanContainer';
import PlanEmpty from './PlanEmpty';
import PlanError from './PlanError';
// import HowItWorks from './HowItWorks';
import MotionLoading from '../../UI/MotionLoading/motionLoading';
import Loading from '../../General/Loading';
import Divider from '../../General/Divider';
// import Button from '../../General/Button';

import { Content } from '../../Marketplace/BundleBuyProcess';

import useUser from '../../../hooks/useUser';
import { GoogleTagManager } from '../../../helpers';

const PlanList = ({ closePanel, segment, setBundleBuySuccess }) => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [error, setError] = useState(false);
  // const [openHowWorks, setHowWorks] = useState(false);
  const user = useUser();
  const cellPhone = user ? user.plan.number : '';

  const [showingBuying, setShowBuying] = useState(false);

  // const showHowWorks = () => {
  //   setHowWorks(!openHowWorks);
  // };

  const [currentBundleData, setCurrentBundleData] = useState({});

  const buyClickHandler = dataBundle => {
    setCurrentBundleData(dataBundle);
    setShowBuying(true);
  };

  const loadData = () => {
    setLoading(true);
    setError(false);

    MarketplaceService.getRecurringPlan()
      .then(res => {
        setData(res[0].category.subcategories[0]);
      })
      .catch(() => {
        setError(true);
      })
      .then(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    GoogleTagManager.pushToDataLayer({
      event: 'pagina-virtual',
      page: '/plan-zero/paso-2',
      pagename: 'Plan Zero - Oferta Plan Zero',
    });

    loadData();
  }, []);

  return (
    <>
      <MotionLoading loading={loading}>
        {!loading &&
          !error &&
          // !openHowWorks &&
          (data.bundles.length === 0 ? (
            <ContainerStyled>
              <HeaderOvalStyled />
              <PlanEmpty closePanel={closePanel} />
            </ContainerStyled>
          ) : (
            !showingBuying && (
              <ContainerStyled>
                <HeaderOvalStyled />
                <WrapperListStyled>
                  <ListTitleStyled>Elige tu Plan Zero</ListTitleStyled>
                  <Divider width="100%" color="#D4C6C6" lineStyle="dashed" />
                  <ContentStyled>
                    <PlanContainer
                      closePanel={closePanel}
                      data={data.bundles}
                      buyCallback={buyClickHandler}
                    />
                  </ContentStyled>
                  <FinalTextStyled>
                    <p>
                      Si quieres evitarte la lata de recargar y comprar bolsas
                      cada mes, ésta puede ser la opción perfecta para ti.
                    </p>
                    {/* <Button
                      outline
                      maxWidth="220px"
                      margin="auto"
                      click={() => showHowWorks()}
                    >
                      QUIERO SABER MÁS
                    </Button> */}
                  </FinalTextStyled>
                </WrapperListStyled>
              </ContainerStyled>
            )
          ))}
      </MotionLoading>
      {/* {openHowWorks ? (
        <ContainerStyled>
          <HeaderOvalStyled />
          <HowItWorks setHowWorks={setHowWorks} />
        </ContainerStyled>
      ) : null} */}
      {error ? (
        <ContainerStyled>
          <HeaderOvalStyled />
          <PlanError loadData={loadData} />
        </ContainerStyled>
      ) : null}
      {loading && <Loading />}
      {showingBuying && (
        <ContainerGreyStyled>
          <Content
            setBundleBuySuccess={setBundleBuySuccess}
            bundleData={currentBundleData}
            closePanel={closePanel}
            segment={segment}
            cellphone={cellPhone}
            isRecurring
          />
        </ContainerGreyStyled>
      )}
    </>
  );
};

PlanList.propTypes = {
  closePanel: PropTypes.func.isRequired,
  segment: PropTypes.string.isRequired,
  setBundleBuySuccess: PropTypes.func.isRequired,
};

export default PlanList;
